<a class="tick-button" [ngClass]="{'disable-hover': disableHover, 'selected': selected, 'clear': clear, 'disable-click': disableClick}">
  <ng-content></ng-content>
</a>



// WEBPACK FOOTER //
// ./src/app/shared/components/buttons/tick-button/tick-button.component.html